import { Link } from "react-router-dom";

const cards = [
  {
    icon: "ri-group-line",
    title: "Hisseli Satış",
    desc: "Dana ve düve hisse seçenekleriyle size uygun paketi kolayca belirleyin.",
  },
  {
    icon: "ri-cow-line",
    title: "Kurbanlık Satışı",
    desc: "Büyükbaş ve küçükbaş kurbanlıklar için güvenilir çiftlik hizmeti alın.",
  },
  {
    icon: "ri-heart-line",
    title: "Adaklık Hizmeti",
    desc: "Adaklık ve özel kesim ihtiyaçlarınız için bizimle WhatsApp üzerinden görüşün.",
  },
];

export default function ServicesOverview() {
  return (
    <section id="hizmetler" className="bg-farm-warm py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-9">
          <span className="font-body text-xs font-bold tracking-[0.24em] text-farm-earth">
            HİZMETLER
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl font-bold text-farm-brown leading-tight">
            Sade, şık ve anlaşılır hizmet yapısı
          </h2>
          <p className="mt-3 font-body text-base text-farm-muted leading-relaxed">
            Kurbanlık, adaklık ve hisseli satış süreçlerinde güvenilir iletişim, hijyenik kesim ve zamanında teslimat odağımızdır.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {cards.map((card) => (
            <Link
              key={card.title}
              to="/hizmetler"
              className="group rounded-[28px] border border-farm-border bg-farm-cream p-7 shadow-sm hover:-translate-y-1 hover:shadow-lg transition-all"
            >
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-farm-green-pale text-farm-green">
                <i className={`${card.icon} text-3xl`} />
              </div>
              <h3 className="mt-6 font-heading text-2xl font-bold text-farm-brown">{card.title}</h3>
              <p className="mt-2 font-body text-sm text-farm-muted leading-relaxed">{card.desc}</p>
              <div className="mt-6 inline-flex items-center gap-2 text-farm-earth font-body text-sm font-bold">
                Detayları Gör
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
